;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { IconName, iconSpriteHref } from '@qogita/svg-icons'
import { type SVGProps } from 'react'

import { cn } from '../../utils/cn'

export { type IconName, iconSpriteHref }

export function Icon({
  name,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { name: IconName }) {
  return (
    <svg
      {...props}
      className={cn('h-6 w-6 shrink-0', className)}
      aria-hidden="true"
    >
      <use href={`/sprites/icons/${iconSpriteHref}#${name}`} />
    </svg>
  )
}
